(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-excelsa-world-cards"] && !Shopify.designMode) return;
  try {
    
function initExcelsa(root){if(root.dataset.ready)return;root.dataset.ready='true';root.classList.add('is-ready');const track=root.querySelector('.ex-track'),cards=[...track.children],controls=root.querySelector('.ex-controls'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]'),count=root.querySelector('[data-count]');controls.hidden=false;let index=0;const update=()=>{index=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left)<Math.abs(cards[best].getBoundingClientRect().left-track.getBoundingClientRect().left)?i:best,0);if(track.scrollLeft+track.clientWidth>=track.scrollWidth-5)index=cards.length-1;count.textContent=count.textContent.replace(/^\d+/,String(index+1));prev.disabled=index===0;next.disabled=index===cards.length-1};const go=(n)=>{const card=cards[Math.max(0,Math.min(cards.length-1,n))];track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'auto'})};prev.addEventListener('click',()=>go(index-1));next.addEventListener('click',()=>go(index+1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1))}});root.querySelector('[data-open-research]').addEventListener('click',e=>{e.preventDefault();const detail=root.querySelector('details');detail.open=true;detail.scrollIntoView({block:'start'});detail.querySelector('summary').focus({preventScroll:true})});update()}
document.querySelectorAll('.ex-world').forEach(initExcelsa);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ex-world').forEach(initExcelsa));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-excelsa-world"] && !Shopify.designMode) return;
  try {
    
function initExcelsa(root){if(root.dataset.ready)return;root.dataset.ready='true';root.classList.add('is-ready');const track=root.querySelector('.ex-track'),cards=[...track.children],controls=root.querySelector('.ex-controls'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]'),count=root.querySelector('[data-count]');controls.hidden=false;let index=0;const update=()=>{index=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left)<Math.abs(cards[best].getBoundingClientRect().left-track.getBoundingClientRect().left)?i:best,0);if(track.scrollLeft+track.clientWidth>=track.scrollWidth-5)index=cards.length-1;count.textContent=count.textContent.replace(/^\d+/,String(index+1));prev.disabled=index===0;next.disabled=index===cards.length-1};const go=(n)=>{const card=cards[Math.max(0,Math.min(cards.length-1,n))];track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'auto'})};prev.addEventListener('click',()=>go(index-1));next.addEventListener('click',()=>go(index+1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1))}});root.querySelector('[data-open-research]').addEventListener('click',e=>{e.preventDefault();const detail=root.querySelector('details');detail.open=true;detail.scrollIntoView({block:'start'});detail.querySelector('summary').focus({preventScroll:true})});update()}
document.querySelectorAll('.ex-world').forEach(initExcelsa);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ex-world').forEach(initExcelsa));

  } catch(e) { console.error(e); }
})();
})();
